import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {styled, TableCell, tableCellClasses, TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


export default function ContributionExternalSourceQueryDialog(props) {
    const setExternalSourceQueryDialogOpen = props.setExternalSourceQueryDialogOpen;
    const externalSourceQueryDialogOpen = props.externalSourceQueryDialogOpen;
    const externalSourceQueryInfo = props.externalSourceQueryInfo;

    const handleClose = () => {
        setExternalSourceQueryDialogOpen(false);
    };

    const convertCamelcaseToCapitalCase = (camelStr) => {
        return camelStr
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (s) => {
                return s.toUpperCase();
            })
            .replace(/Num Of /g, '')
    }



    return (
        <div>
            {externalSourceQueryInfo &&
                <Dialog
                    open={externalSourceQueryDialogOpen}
                    onClose={handleClose}
                    aria-labelledby="externalSourceQueryInfo-dialog-title"
                    aria-describedby="externalSourceQueryInfo-dialog-description"
                    maxWidth='md'
                >
                    <DialogTitle id="externalSourceQueryInfo-dialog-title">
                        External Data Source Query Information
                    </DialogTitle>
                    <DialogContent>
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650, m: 0}} size="small">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell sx={{width: 400}}>External Data Source</StyledTableCell>
                                        <StyledTableCell>Counts</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.entries(externalSourceQueryInfo).map(([key, value], i) => (
                                        <StyledTableRow
                                            key={i}
                                        >
                                            <StyledTableCell component="th" scope="row">
                                                {/*{externalSourceQueryInfoMapping[key]}*/}
                                                {convertCamelcaseToCapitalCase(key)}
                                            </StyledTableCell>
                                            <StyledTableCell>{value}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </DialogContent>
                    <DialogActions sx={{display: 'flex', justifyContent: 'center', padding: '0 8px 12px 8px'}}>
                        <Button onClick={handleClose} autoFocus variant='contained'>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </div>
    );
}
